const { throwError } = require('./ab-helpers');
const abTypes = require('./ab-types');

const abVariantCalculator = $ => {
  if (!$) {
    throwError('[abClient] jQuery parameter required');
  }

  const calculateVariant = (options, callback) => {
    $.ajax({
      type: 'GET',
      contentType: 'application/json',
      dataType: 'json',
      url: options.url,
      data: options.experiment,
      headers: { Accept: 'application/vnd.oc.unrendered+json' }, // info: this is used by oc
      success: ({ data }) => {
        callback({ type: abTypes.VARIANT_CALCULATED, payload: parseInt(data.variant, 10) });
      },
      error: (jqXHR, textStatus, errorThrown) => {
        throwError(errorThrown);
      }
    });
  };

  return {
    calculateVariant
  };
};

module.exports = abVariantCalculator;



// WEBPACK FOOTER //
// ./src/ab-variant-calculator.js